import React from 'react'
import { PagamentoProtocol } from '../../Pages/Pagamento/interfaces'
import { Container } from './styles'
interface PaymentCardProps {
    pagamento: PagamentoProtocol
}
const PaymentCard: React.FC<PaymentCardProps> = ({ pagamento }) => {
    return (
        <Container>
            <p><span>Beneficiario: </span>{pagamento.beneficiario}</p>
            <p><span>Data liquidação efetiva: </span>{pagamento.dataLiquidacaoEfetiva}</p>
            <p><span>Valor a pagar: </span>{pagamento.valorAPagar}</p>
            <p><span>Valor liquidção efetiva: </span>{pagamento.valorLiquidacaoEfetiva}</p>
            <p><span>Valor onerado: </span>{pagamento.valorOnerado}</p>
            <p><span>Nome do titular: </span>{pagamento.dp_nomeTitular}</p>
            <p><span>Número documento titular: </span>{pagamento.dp_numeroDocumentoTitular}</p>
            <p><span>Tipo da conta: </span>{pagamento.dp_tipoConta}</p>
            <p><span>Agenda: </span>{pagamento.dp_agencia}</p>
            <p><span>Número da conta: </span>{pagamento.dp_numeroConta}</p>
            <p><span>ispb: </span>{pagamento.dp_ispb}</p>
            <p><span>Compe: </span>{pagamento.dp_compe}</p>
        </Container>
    )
}

export default PaymentCard